
import {finalize} from 'rxjs/operators';
import { Component, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { NotifierService, DialogService } from '../ui';
import { find, filter, map, remove } from 'lodash';

import { OrganigrammeService, OrganigrammeEntityLinkResult } from './organigramme.service';
import { OrganigrammeEntityLink } from './model/entity-link';
import { OrganigrammeEntity } from './model/entity';

const isSelected = (l: OrganigrammeEntityLink) => l.selected;

@Component({
  selector: 't-add-node-menu',
  templateUrl: './add-node-menu.component.html',
  host: {
    class: 'add-node-menu closed'
  }
})
export class AddNodeMenuComponent implements OnChanges {
  
  @Input() entity: OrganigrammeEntity
  @Output() entityChange = new EventEmitter();

  @Input() currentEntities: OrganigrammeEntity[];

  @Output() entitiesAdded = new EventEmitter();

  links: OrganigrammeEntityLinkResult

  constructor(
    private organigrammeService: OrganigrammeService,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.entity) {
      if(this.entity) {
        delete this.links;
        
        this.fetch();
      }
    }
  }

  private fetch() {
    this.notifier.startProgress();

    this.organigrammeService
      .links(this.entity.dossier_id, this.entity.record_id).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        // Remove current entities from the result
        this.removeCurrentEntities(result.belongs_to);
        this.removeCurrentEntities(result.has_shares_in);
        
        this.links = result;
      });
  }

  private removeCurrentEntities(links: OrganigrammeEntityLink[]) {
    remove(links, l => {
      return find(this.currentEntities, e => e.id === l.entity.id);
    });
  }

  add() {
    let links = [
      ...filter(this.links.belongs_to, isSelected),
      ...filter(this.links.has_shares_in, isSelected),
    ];

    let entities = map(links, l => l.entity);

    this.entitiesAdded.emit(entities);
  }

  cancel() {
    this.entityChange.emit(null);
  }

  get hasSelected() {
    if(!this.links) {
      return false;
    }

    return find(this.links.belongs_to, isSelected) || find(this.links.has_shares_in, isSelected);
  }

  
}
